import ahoy from 'ahoy.js';

export default () => {
  const events = {
    track(name, params = {}) {
      ahoy.track(name, { ...params, parent_url: document.referrer });
    }
  };

  return events;
};
